import { Base } from 'layouts'
import { ProtocolsList } from 'components'

import * as S from './styled'

export function Protocols() {
  return (
    <Base>
      <S.GridContainer container>
        <ProtocolsList />
      </S.GridContainer>
    </Base>
  )
}
